import { useTranslation } from 'react-i18next';
import type { VehicleInfo } from '../types';
import type { DealerLocationData } from './useGetDealerDetails';

const useCreateMetaTitle = (
  vehicleData: VehicleInfo | undefined,
  dealerInfo: DealerLocationData | undefined,
) => {
  const { t } = useTranslation();

  if (!vehicleData) return t('vdpHeader.metaTitle.noAvailableVehicle');

  const vehicleType = vehicleData.vehicleType;
  const modelName = vehicleData.modelName;
  const trimName = vehicleData.trimName;
  const audiCode = vehicleData.audiCode;
  const dealerName = dealerInfo?.name;
  const city = dealerInfo?.city;
  const stockNumber = vehicleData.stockNumber;
  const state = dealerInfo?.region;

  const vehicleNumber = vehicleType === 'non-audi' ? stockNumber : audiCode;
  const isNew = vehicleType === 'new';
  const newDetails = `${trimName} | ${dealerName}`;
  const usedDetails = `${t('vdpHeader.metaTitle.usedDetails')} ${city}, ${state}`;

  const typeSpecificDetails = isNew ? newDetails : usedDetails;

  const title = `${isNew ? t('vdpHeader.metaTitle.intro') : ''} ${modelName} ${typeSpecificDetails} | ${vehicleNumber}`;

  return title.trimStart();
};

export default useCreateMetaTitle;
